import { MediaStatusType } from '@lib2/model/media/MediaTypes';
import { ACTIVE_JOB_STATUSES } from '@/lib/constants/ingest';
import type { JobData, JobViewsData } from '@/lib/types/Job';

/** Media statuses that can carry an active ingest/transcode job. */
export const PROCESSING_MEDIA_STATUSES: readonly MediaStatusType[] = [
  MediaStatusType.AwaitingIngest,
  MediaStatusType.Ingesting,
  MediaStatusType.Processing,
];

export class JobProgressUtils {
  /**
   * Per-media percent complete (0-100) from the polled job list. Ingest and
   * transcode jobs that are still active count; when a media has several,
   * the most recently updated one wins (legacy Job.store semantics).
   */
  static buildMediaProgressMap(jobs: JobViewsData | undefined): Map<number, number> {
    const result = new Map<number, number>();
    if (!jobs) return result;

    const latest = new Map<number, JobData>();
    for (const job of [...jobs.ingestVideoJobs, ...jobs.transJobs]) {
      const mediaId = job.ids.mediaId;
      if (mediaId === null) continue;
      if (!(ACTIVE_JOB_STATUSES as readonly string[]).includes(job.jobStatus)) continue;
      const prev = latest.get(mediaId);
      if (!prev || job.updated > prev.updated) latest.set(mediaId, job);
    }

    for (const [mediaId, job] of latest) {
      result.set(mediaId, Math.min(100, Math.max(0, job.completedRate)));
    }
    return result;
  }
}
